//  libraries
import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'

export default function TableLoading () {
  return <thead><tr><td colSpan='99'><LinearProgress /></td></tr></thead>
}
